import { render, staticRenderFns } from "./PhaseCard.vue?vue&type=template&id=72e9fdcf&scoped=true&"
import script from "./PhaseCard.vue?vue&type=script&lang=js&"
export * from "./PhaseCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e9fdcf",
  null
  
)

export default component.exports